import React, { useEffect, useState } from 'react';
import {
  ValidSectionId,
  ValidActionType,
} from 'src/ReduxStorage/InstitutionAdminSettings/types';
import { ConnectedViewTeamMembers } from 'src/web/containers/InstitutionAdminSettings/TeamPage/ViewTeamMembers/connector';
import { ConnectedAddMember } from '../components/AddMember/connector';
import { ConnectedRecentlyAddedMembers } from '../components/RecentlyAddedMembers/connector';
import { ConnectedRecentlyAssignedCourses } from '../components/RecentlyAssignedCourses/connector';
import { StyledTabPane, StyledTabs } from '../styles';

export const TeamPage: React.FC<{
  queryObject: { [key: string]: string };
  navigateTo: (sectionId: ValidSectionId, action: ValidActionType) => void;
}> = ({ queryObject, navigateTo }) => {
  const { action } = queryObject;
  const [navState, setNavState] = useState<ValidActionType>(
    ValidActionType.VIEW_MEMBER
  );

  const handleChangeNavState = (nav: ValidActionType): void => {
    setNavState(nav);
  };

  useEffect(() => {
    switch (action as ValidActionType) {
      case ValidActionType.ADD_MEMBER:
      case ValidActionType.RECENT_ADDED_MEMBER:
      case ValidActionType.RECENT_ASSIGNED_COURSE:
        setNavState(action as ValidActionType);
        break;
      default:
        setNavState(ValidActionType.VIEW_MEMBER);
        break;
    }
  }, [action]);

  const onChangeNavState = (nav: ValidActionType): void => {
    const currentSection = ValidSectionId.TEAM;
    switch (nav) {
      case ValidActionType.ADD_MEMBER:
      case ValidActionType.RECENT_ADDED_MEMBER:
      case ValidActionType.RECENT_ASSIGNED_COURSE:
        navigateTo(currentSection, nav);
        break;
      default:
        navigateTo(currentSection, ValidActionType.VIEW_MEMBER);
        break;
    }
  };

  return (
    <>
      <StyledTabs
        destroyInactiveTabPane
        activeKey={navState}
        onChange={(key) => onChangeNavState(key as ValidActionType)}
      >
        <StyledTabPane
          tab="View team members"
          key={ValidActionType.VIEW_MEMBER}
        >
          <ConnectedViewTeamMembers changeNavState={handleChangeNavState} />
        </StyledTabPane>
        <StyledTabPane tab="Add team members" key={ValidActionType.ADD_MEMBER}>
          <ConnectedAddMember memberType="team members" />
        </StyledTabPane>
        <StyledTabPane
          tab="Recently added team members"
          key={ValidActionType.RECENT_ADDED_MEMBER}
        >
          <ConnectedRecentlyAddedMembers memberType="team members" />
        </StyledTabPane>
        <StyledTabPane
          tab="Recently assigned courses"
          key={ValidActionType.RECENT_ASSIGNED_COURSE}
        >
          <ConnectedRecentlyAssignedCourses memberType="team members" />
        </StyledTabPane>
      </StyledTabs>
    </>
  );
};
